<template>
	<div :class="['questionnaire', 'analysis', { 'is-survey': isSurvey }, { 'is-not-survey': !isSurvey }]">
		<div class="questions card" v-for="(question, i) in questionnaireContent.question" :key="question.id + i">
			<span class="text">
				{{ i + 1 }}. {{ question.title }} <span class="question-desc">({{ question.question }})</span>
				<AnalysisArchive v-if="question.archive" />
				<span class="flag-container" v-for="flag in getFlags(question.id)" :key="isResolved(flag) ? flag.resolved_time : flag.modified_time">
					<el-popover
						placement="bottom"
						width="400"
						trigger="hover"
						v-if="getUserType === 'observer' && isSurvey && flag.hasOwnProperty('modified_by')"
						class="comment-modal">
						<button :class="['flag', isResolved(flag) ? 'flag-resolved' : 'flag-unresolved']" @click="addFlag(i)" slot="reference">
							{{ getDateString(flag.modified_time) }}
							<img :src="require(isResolved(flag) ? './response/icon/flag-resolved.png' : './response/icon/flag-unresolved.png')" class="flag-image">
						</button>
						<div class="body" >
							<span class="flag-container-image" :style="isResolved(flag) ? 'backgroundColor: #EDF8DF': 'backgroundColor: #FFEBEB'">
								<img :src="require(isResolved(flag) ? './response/icon/flag-resolved.png' : './response/icon/flag-unresolved.png')" class="flag-image">	
							</span>
							<span class="comment" v-html="flag.comment"></span>
						</div>
						<span class="added-by">Added by {{ flag.modified_name }} on 
							{{ getDateTimeString(flag.modified_time) }}
						</span>
					</el-popover>
				</span>
			</span>
			<div v-if="getResponses(question.id) == null">
				Patient did not answer
			</div>
			<div v-else
				:is="responseType(question)"
				:question="question"
				v-bind:response="getResponses(question.id)"
				:oresponse="getOResponse(question.id)"
				v-bind:questionnaire="orderedQuestionnaires"
				v-bind:patient="patient"
				@addFlagObj="addNewFlag"
				:qNum="i+1"
				:is-survey="isSurvey"
				:cnstFrmCnntd="checkIfConsFrmQuestConnected(question)">
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CardAnalysis from '../../component/analysis'
import Responses from './response/components'
import responseMap from './response/map'
import AnalysisArchive from './AnalysisArchive'

import formatDateTime from '@/module/util/format-date-time'
import isEmptyObj from '@/module/util/empty-object'


export default {
	name: 'questionnaire-card-analysis',
	extends: CardAnalysis,

	props: {
		questionnaire: {
			type: Array,
			required: true
		},
		id: {
			type: String,
			required: true
		},
		patient: {
			type: Object,
			required: true
		},
		isSurvey: {
			type: Boolean
		}
	},

	data() {
		return {}
	},

	methods: {
		addNewFlag(flag) {
			this.questionnaire.forEach(q => {
				if (q.id === flag.problem_id) {
					if (!q.hasOwnProperty('problem'))
						q.problem = []
					q.problem.push(flag)
				}
			})
		},
		getDateString(timestamp) {
			let date = new Date(timestamp).toDateString()
			return date.split(' ')[1] + ' ' + date.split(' ')[2]
		},
		getDateTimeString(timestamp) {
			let strTime = this.formatDateTime(new Date(timestamp))
			strTime = strTime.replace(' at', ',')
			return strTime
		},
		isResolved(flagObj) {
			if (flagObj.hasOwnProperty('resolved_by') || flagObj.hasOwnProperty('resolved_time') || flagObj.hasOwnProperty('resolved_name'))
				return true
			return false
		},
		/**
		 * @returns Array of objects i.e flags from different questionnaires given the question id
		 */
		getFlags(id) {
			let problems = []
			this.questionnaire.filter(question => question.hasOwnProperty('problem') && question.problem.length)
			.forEach(question => {
				question.problem.filter(problem => problem.question_id === id)
				.forEach(p => problems.push(p))
			})
			return problems
		},
		responseType(question) {
			return responseMap[question.type]
		},
		getResponses(id) {
			return this.orderedQuestionnaires
			.map((questionnaire) => {
				let response = questionnaire.question.find((response) => (response != null && response.id === id)),
					question = this.questionnaireContent.question.find((question) => question.id === id),
					newResponse
				if (response)
					newResponse = response.answer || response.value
				if(response && (response.image_url || response.image_description))
					newResponse = response
				if(newResponse && this.checkNullAnswer(question,newResponse))
					return null

				
				if(Array.isArray(newResponse) && newResponse.length > 0 && (newResponse.some((resObj) => resObj && resObj.value) || (newResponse[0] && newResponse[0].answer)))
					newResponse = this.getOldAnswer(question, newResponse)

				
				return newResponse
			})
			// Filter skipped responses for questions
			// .filter((r) => (r != null))
		},
		getOResponse(id) {
			return this.orderedQuestionnaires.map((questionnaire) => {
				let response = questionnaire.question.find((response) => (response != null && response.id === id)),
					question = this.questionnaireContent.question.find((question) => question.id === id),
					newResponse
				if(response && (response.image_url || response.image_description))
					newResponse = response
				if (response)
					newResponse = response.answer || response.value || response.image_url

				return newResponse
			})
		},
		getResponse(questionContent, questionnaire) {
			return questionnaire.question.find((questionResponse) => {
				return questionResponse != null && questionResponse.id == questionContent.id
			})
		},
		checkNullAnswer(question, answer) {
			if(question.type === 'text' && answer[0] && answer[0].answer === null)
				return true
			if(question.type === 'unit' && answer[0] && isEmptyObj(answer[0]))
				return true
			return false
		},
		getOldAnswer (question, answer) {
			let oldAnswer = answer
			//console.log(answer)
			if(question.type === 'select') {
				oldAnswer = answer.map((ansObj) => ansObj.value)
			}

			else if (['box_select', 'large_image_select', 'small_image_select'].includes(question.type)) {
				oldAnswer = answer.reduce((accAns, ansObj) => {
					const selectArr = Object.entries(question.select).find(([key, value]) => ansObj.value === value)
					if(selectArr)
						accAns[selectArr[0]] = selectArr[1]
					return accAns
				}, {})
				if(question.type === 'box_select')
					oldAnswer.other  = answer.
						filter((ansObj) => !Object.values(question.select).some((value) => ansObj.value === value))
						.map(({value}) => value)

			}

			else if(['scroller', 'slider'].includes(question.type)) {
				oldAnswer = Array.isArray(answer) && (answer.length === 1) ? { [answer[0].value] : question.label[answer[0].value] } : null
			}

			else if(question.type === 'star') {
				oldAnswer = { [answer[0].value]: question.label[answer[0].value] }
			}

			else if(question.type === 'radio') {
				oldAnswer =  parseInt(answer[0].value) + 1
			}
			
			else if(question.type === 'human_map') {
				oldAnswer = answer.map(({value}) => value)
			}

			else if(question.type === 'binary')
				oldAnswer = Array.isArray(answer) && (answer.length === 1) ? { 0 : answer[0].value } : null

			else if(question.type === 'text' && answer.length === 1 && answer[0].answer)
				oldAnswer = { 0 : answer[0].answer }
			
			else if(question.type === 'image_upload')
				oldAnswer = {
					image_url: answer[0].value,
					image_description: answer[0].answer
				}
			else if(question.type === 'sign_document') {
				oldAnswer = answer
				oldAnswer[0].image_url = oldAnswer[0].value
			}
				
			return oldAnswer
		},
		getInsideDoubleCurly(str) {
			return str.split('{{').filter(val => val.includes('}}')).map(val => val.substring(0, val.indexOf('}}')).trim())
		},
		checkIfConsFrmQuestConnected(quest) {
			if(quest.type === 'multi_question') {
				let subQuestIds = quest.questions.map(subQuest => subQuest.id)
				return subQuestIds.some((subId) => this.consFrmCnntdQuestIds.includes(subId))
			} else return this.consFrmCnntdQuestIds.includes(quest.id)
		}
	},

	computed: {
		...mapGetters(["getUserType"]),
		...mapGetters('provider', [
			'getPatientEvents'
		]),
		patientEvents() {
			return this.getPatientEvents(this.patient.id)
		},
		/**
		 * @func questionnaireContent
		 * @desc The underlying content object for this questionnaire.
		 */
		questionnaireContent() {
			let content = { ...this.getContent('questionnaire', this.id)}
			content.question = [ ...content.question.flatMap((question, index) => {
				if(question.type === 'section_separator')
					return []
				if(question.type === 'questionnaire') {
					let subContent = this.getContent('questionnaire', question.questionnaire)
					if(subContent && subContent.question) {
						return subContent.question.filter(({ type }) => type && type !== 'section_separator')
							.map((subQ) => ({
								...subQ,
								id: question.id + '_' + subQ.id,
								archive: question.archive || subQ.archive
							}))
					}
					return []
				}
				else if(Array.isArray(question.options) && question.options.length > 0 && question.options.some(({questionnaire}) => questionnaire)) {
					return [
						question,
						...question.options
							.filter(({questionnaire}) => questionnaire)
							.filter(({questionnaire, id}) => {
								let found = false
								this.orderedQuestionnaires.filter(questionObj => {
									questionObj.question
									.filter(q => q && q.id === question.id)
									.forEach(q => {
										//console.log('q.answer', q.answer, questionnaire, question)
										//console.log('filtered subqs', q.answer.filter(ans => id === ans.id))
										if (Array.isArray(q.answer) && q.answer.filter(ans => id === ans.id).length)
											found = true
									})
								})
								return found
							})
							.flatMap(({questionnaire}) => {
								let subContent = this.getContent('questionnaire', questionnaire)
								if(subContent && subContent.question) {
									return subContent.question.filter(({ type }) => type && type !== 'section_separator')
										.map((subQ) => ({
											...subQ,
											id: question.id + '_' + subQ.id,
											archive: question.archive || subQ.archive
										}))
								}
								return []
							})]
				}
				else
					return [question]

			})]


			content.question = content.question.filter((question) => !question.ref_question)

			return content
		},

		/**
		 * @func orderedQuestionnaires
		 * @desc Questionnaires ordered in reverse chronological order
		 */
		orderedQuestionnaires() {
			return JSON.parse(JSON.stringify(this.questionnaire))
				.filter((q) => q.completed)
				.map((q) => {
					q.question = q.question.flatMap((questionObj) => {
						if(questionObj && questionObj.questionnaire) {
							const subQuestion = questionObj.questionnaire
							let branchAns = []
							if(questionObj.answer)
								branchAns = [questionObj]
							if(Array.isArray(subQuestion) && subQuestion.length > 0)
								return [
									...branchAns,
									...subQuestion.flatMap(({question}) => question.map((subQ) => ({
										...subQ,
										id: questionObj.id + '_' + subQ.id
									})))
								]
						}
						return [questionObj]
					})
					return q
				})
				.sort((a, b) => (b.completed - a.completed))
		},
		consFrmCnntdQuestIds() {
			let consFrmCnntdQuests = []

			let signedQuest = this.questionnaireContent && 
								this.questionnaireContent.question && 
								!!this.questionnaireContent.question.length && 
								this.questionnaireContent.question.find(quest => quest.type === 'sign_document')

			if(signedQuest && signedQuest.attachments && !!signedQuest.attachments.length) {
				let signedQuestTxt = signedQuest.attachments[0].text ? signedQuest.attachments[0].text : ''
				consFrmCnntdQuests = this.getInsideDoubleCurly(signedQuestTxt)
			}

			return consFrmCnntdQuests
		}
	},

	components: {
		...Responses,
		formatDateTime,
		AnalysisArchive
	}
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";
@import "../../component/table/style/analysis.scss";

.questions.card {
	display: flex;
	flex-direction: column;
	padding: 0;
	margin-top: 0;
	.text {
		margin: 12px 14px;
		font-size: 13px;
		font-weight: 700;
		color: $black-color;
		.question-desc {
			color: $dark-grey;
			font-size: 12px;
			font-weight: normal;
			margin-left: 8px;
		}
	}
	.title {
		font-size: 12px;
		font-weight: 500;
		color: #7f7f7f;
	}
}
.flag {
	margin-left: 7px;
}
.flag-image {
	width: 8px;
    height: 10px;
}
.flag-container-image {
    display: inline-block;
    width: 18px;
    height: 18px;
    padding: 0px 0 2px 5px;
    border-radius: 50%;
}
.flag-unresolved {
	background: #FFEBEB;
	border: 1px solid #DA4E4E;
	border-radius: 10px;
	width: 65px;
	height: 20px;
	font-weight: normal;
	font-size: 12px;
	line-height: 15px;
	color: #333333;
	margin-bottom: 5px;
}
.flag-resolved {
	background: #E7FFEA;
	border: 1px solid #44B358;
	border-radius: 10px;
	width: 65px;
	height: 20px;
	font-weight: normal;
	font-size: 12px;
	line-height: 15px;
	color: #333333;
	margin-bottom: 5px;
}
.body {
	width: 100%;
	padding-top: 7px;
	padding-bottom: 7px;
}
.added-by {
	display: block;
	margin-top: 4px;
	font-size: 12px;
	font-weight: normal;
	line-height: 16px;
	color: #828282;
}
.comment {
	padding-left: 10px;
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
	color: #333333;
}
</style>
